import React from "react";
import { Link } from "react-router-dom";

import "./styles.css";

const Render = (props, context) => {
  return (
    <section className="passwordReset pbxl backgroundImage">
      <div className="container">
        <ul className="breadcrumbs horizontal clearfix">
          <li>
            <Link to="/dashboard" className="avenirBK white">
              Perfil
            </Link>
          </li>
          <li>
            <h1 className="avenirBK white">Cambiar Contraseña</h1>
          </li>
        </ul>
        {props.error && (
          <p className={`formMsg pvl mha alignCenter`}>{props.error}</p>
        )}
        <form className="mha" onSubmit={props.onSubmit}>
          <div>
            <label htmlFor="passwordNewCreate" className="mha">
              <span className="labelName white">Ingresar nueva contraseña</span>
              <input
                type="password"
                name="passwordNewCreate"
                id="passwordNewCreate"
                className="passwordNewCreate"
              />
            </label>

            <label htmlFor="passwordNewConfirm" className="mha">
              <span className="labelName white">Repetir nueva contraseña</span>
              <input
                type="password"
                name="passwordNewConfirm"
                id="passwordNewConfirm"
                className="passwordNewConfirm"
              />
            </label>
          </div>

          <input type="submit" value="Cambiar Contraseña" className="btn mha btnGold" />
        </form>
      </div>
    </section>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/PasswordReset/Render.js